<template>
  <div>
    <v-row>
      <v-col>
        <AppTextField
          :model-value="fileName"
          required
          class="required document-name-input"
          :disabled="isEditingLimited"
          :label="$t('project.signing-checklist.add.SigningChecklistSectionDocumentTitle.titleLabel')"
          counter="70"
          maxlength="70"
          :error-messages="titleErrorMessages"
          @update:model-value="onTitleChange"
        >
        </AppTextField>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import AppTextField from '@/common/AppTextField.vue'
import { formFieldErrors, VuelidateFormField } from '@/common/utils/form'

export default defineComponent({
  name: 'SigningChecklistSectionDocumentTitle',
  components: {
    AppTextField,
  },
  props: {
    fileName: {
      type: String,
      required: true,
    },
    isEditingLimited: {
      type: Boolean,
      required: true,
    },
    titleValidator: {
      type: Object as PropType<VuelidateFormField>,
      required: true,
    },
  },
  computed: {
    titleErrorMessages () {
      return formFieldErrors(
        this.titleValidator,
        [
          ['required', this.$t('common.validations.fieldRequired', { fieldName: this.$t('project.signing-checklist.add.SigningChecklistSectionDocumentTitle.titleLabel') })],
        ],
      )
    },
  },
  methods: {
    onTitleChange (title: string) {
      this.$emit('title-change', title.trim())
    },
  },
})
</script>
